import React, { useMemo } from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useGetCompanyTypes } from "@/services/RegisterCompany";
import { useTranslation } from "react-i18next";

interface SelectCompanyTypeProps extends SelectProps {
  showAdminOption: boolean;
  /** When set, only these company types are offered. */
  allowedTypes?: readonly string[];
}

const SelectCompanyType: React.FC<SelectCompanyTypeProps> = ({
  showAdminOption = false,
  allowedTypes,
  ...restProps
}) => {
  const { data: companyTypeOptions, isLoading } = useGetCompanyTypes();
  const { t } = useTranslation();

  const filteredOptions = useMemo(
    () =>
      (companyTypeOptions ?? [])
        .filter((option) => showAdminOption || option.toLowerCase() !== "admin")
        .filter((option) => !allowedTypes || allowedTypes.includes(option.toUpperCase())),
    [showAdminOption, allowedTypes, companyTypeOptions]
  );

  const options = transformDataToSelectOption(filteredOptions, "", "", t, "enumerables:companyTypes");

  return <Select data={options} loading={isLoading} {...restProps} />;
};

export default SelectCompanyType;
